import { useRouter } from "next/router";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "@redux/action/confirm";

import _ from "lodash";
import { useQueryClient } from "@tanstack/react-query";

import { yupResolver } from "@hookform/resolvers/yup";
import { Spinner } from "react-bootstrap";

import { PackagingDeleteSet, PackagingInsertSet } from "@api/packagingBasket";
import { getUserInfo } from "@api/getUserInfo";
import { ItemCheckPackaging } from "@api/packaging";
import { failAlert, successAlert } from "@common/alert";
import Layout from "@components/layout/Layout";
import { CustomizingSchema } from "@common/util/customizingSchema";
import { FormProvider, useForm } from "react-hook-form";
import CustomizingCate from "@components/customizing/customizingProducts/CustomizingCate";
import * as C from "@components/customizing/customizingProducts/Customizing.styles";
import ImageSlider from "@components/customizing/customizingProducts/new/ImageSlider";
import ProductDetail from "@components/customizing/customizingProducts/new/ProductsDetail";
import CustomizingModal from "@components/customizing/customizingProducts/CustomizingModal";

import { useGetGalleryList } from "@/hook/customizing/customizing-products/useGalleryListQuery";
import { useGetCustomBasketList } from "@/hook/customizing/customizing-products/useCustomBasketQuery";
import { useGetCategoryDetailList } from "@/hook/customizing/customizing-products/useCategoryDetailQuery";
import CustomizingHeader from "@/components/customizing/customizingProducts/new/CustomizingHeader";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const CustomizingDetailPage = ({
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  dummyList,
}) => {
  const cateRef = useRef();
  const router = useRouter();
  const queryClient = useQueryClient();
  const [category, setCategory] = useState();

  // 입력 정보
  const [cnt, setCnt] = useState("");
  const [cntError, setCntError] = useState("수량을 입력해주세요.");

  // 유저 여부
  const [isUser, setIsUser] = useState(false);
  // 카테고리 불러오기 loading
  const [cateLoading, setCateLoading] = useState(false);

  // 제작사례 & 포장재리뷰 불러오기
  const { data: galleryData } = useGetGalleryList();

  // 장바구니 리스트 불러오기
  const { data: basketData, refetch: refetchBasket } = useGetCustomBasketList();

  // 카테고리 상세내용 불러오기
  const { data: detailData } = useGetCategoryDetailList(
    router.query.code,
    setCateLoading
  );

  // 바로 견적 요청
  const directConfirm = async () => {
    if (cnt === "") {
      failAlert("수량을 입력해주세요.");
      setCntError("수량을 입력해주세요.");
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
      }, [200]);
      return;
    }
    if (
      Object.values(methods.getValues()).includes("") ||
      Object.values(methods.getValues()).includes(null) ||
      Object.values(methods.getValues()).includes(undefined)
    ) {
      failAlert("내용을 전부 채워주세요");
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
      }, [200]);
      return;
    }
    const temp = Object.keys(methods.getValues());
    const tempArr = temp.map((el) => ({
      code: el,
      value: methods.getValues()[el],
    }));

    const body = {
      modes: "ItemCheck",
      dcode: category.code,
      cnt: cnt,
      items: JSON.stringify(tempArr),
    };

    const res = await ItemCheckPackaging(body);

    if (res.Code === "0000") {
      sessionStorage.setItem(
        "directBasket",
        JSON.stringify([
          {
            cnt: cnt,
            image: detailData.Image,
            name: dummyList?.make_category[category.code],
            code: category.code,
            options: res.Data?.Row,
            unit: res.Data?.Unit,
            items: JSON.stringify(tempArr),
          },
        ])
      );
      router.push({
        pathname: "/customizing/customizing-cart",
        query: {
          type: "direct",
        },
      });
    }
    if (res.Code === "8888") {
      setCnt(res.Data.Cnt);
      failAlert(
        res.Data?.Msg ? res.Data.Msg : "제작가능한 수량을 확인해주세요."
      );
    }
    if (res.Code === "9999") {
      failAlert(
        res.Data?.Msg ? res.Data?.Msg : "바로 견적 요청에 실패했습니다."
      );
    }
  };

  // 데이터 입력
  const methods = useForm({
    resolver: yupResolver(CustomizingSchema),
  });

  const onChangeUserInputs = (e) => {
    setCnt(e.target.value);
  };
  // 장바구니 담기 form submit
  const submitCart = async (data) => {
    if (cnt === "") {
      failAlert("입력하신 내용을 확인해주세요.");
      setCntError("수량을 입력해주세요.");
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
      }, [200]);
      return;
    }
    if (
      Object.values(data).includes("") ||
      Object.values(data).includes(null) ||
      Object.values(data).includes(undefined)
    ) {
      failAlert("내용을 전부 채워주세요");
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
          top:
            window.innerWidth > 991
              ? cateRef.current.scrollHeight + 100
              : cateRef.current.scrollHeight,
        });
      }, [200]);
      return;
    }
    const temp = Object.keys(data);
    const tempArr = temp.map((el) => ({ code: el, value: data[el] }));
    const body = {
      modes: "InsertSet",
      dcode: category.code,
      cnt: cnt,
      items: JSON.stringify(tempArr),
    };
    const res = await PackagingInsertSet(body);
    if (res.Code === "0000") {
      successAlert("견적 바구니에 담겼습니다.");
      // fetchCustomBasket();
      await queryClient.invalidateQueries(["listSet"]);

      const content = {
        title: "견적 바구니로 이동하시겠습니까?",
        actionBtnLabel: "확인",
        actionBtnValid: true,
        cancelBtnLabel: "견적 추가",
        onClose: () => {
          closeConfirmModal();
          router.reload();
        },
        onAction: () => {
          router.push("/customizing/customizing-cart");
          closeConfirmModal();
        },
      };
      modifyConfirmModal(content);
      openConfirmModal();
    }
    if (res.Code === "8888") {
      setCnt(res.Data?.Cnt);
      failAlert(
        res.Data?.Msg ? res.Data.Msg : "제작가능한 수량을 확인해주세요."
      );
    }
    if (res.Code === "9999") {
      failAlert(
        res.Data?.Msg ? res.Data?.Msg : "견적 바구니 담기에 실패했습니다."
      );
    }
  };
  // 유저 여부
  const checkUser = async () => {
    const res = await getUserInfo();
    if (res.code === "0000") setIsUser(true);
    if (res.code !== "0000") {
      setIsUser(false);
    }
  };
  // 장바구니 삭제
  const deleteBasketItem = async (id) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: async () => {
        const body = {
          modes: "DeleteSet",
          id: id,
        };
        const res = await PackagingDeleteSet(body);
        if (res.Code === "0000") {
          successAlert("삭제되었습니다.");
          // fetchCustomBasket();
          await refetchBasket(); // 장바구니 데이터 재조회
          closeConfirmModal();
        } else {
          failAlert("삭제에 실패했습니다.");
        }
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  useEffect(() => {
    if (!router.isReady) return;

    setCateLoading(true);

    if (router.query.code) {
      setCateLoading(false);
      setCnt("");
      methods.reset({});
      setCategory({ code: router.query.code });
      // fetchCategoryDetail(router.query.code);
    } else {
      setCateLoading(false);
      if (router.query.first) return setCategory("");
      if (router.query.type) return;
      failAlert("카테고리를 먼저 선택해주세요.");
      router.push("/customizing/customizing-products/");
    }
  }, [router.isReady, router.query]);

  useEffect(() => {
    refetchBasket();
    checkUser();
  }, []);

  useEffect(() => {
    if (detailData && router.query.code) {
      setCateLoading(false);
      if (router.query.code === "M0039") {
        setCnt("1");
      }
    }
  }, [detailData]);

  const [introductions, setIntroductions] = useState([]);

  const [modalContents, setModalContents] = useState({
    show: false,
    title: "제목",
    image: "",
  });

  return (
    <>
      <Layout
        noBreadcrumb="d-none"
        parent="홈"
        sub={"맞춤제작"}
        subTitle="견적요청"
        pageTitle={SeoMeta.estimateRequest.title}
        pageDesc={SeoMeta.estimateRequest.description}
        pageKeyword={SeoMeta.estimateRequest.description}
      >
        {cateLoading && (
          <div className="loading_container position-fixed d-flex align-items-center justify-content-center">
            <Spinner animation="border" role="status" />
          </div>
        )}
        <C.CustomNewSection className="container">
          <div
            className="cateWrapper mt-15"
            ref={(ref) => (cateRef.current = ref)}
          >
            <CustomizingCate cateRef={cateRef} />
          </div>
          <div>
            {/* title header */}
            <CustomizingHeader
              isUser={isUser}
              dummyList={dummyList}
              basketData={basketData || []}
              category={category}
              gallery={galleryData}
              deleteBasketItem={deleteBasketItem}
            />
            {/* start: image carousel + input form */}
            {detailData && router.query.code && (
              <C.StepSection>
                {/* 모바일 뷰*/}
                <C.StickyContents className="m_sticky">
                  <C.SideImageWrapper>
                    <img src={detailData.Image} alt="" />
                  </C.SideImageWrapper>
                  <C.SideInfoWrapper>
                    <h4 className="title">상품 안내 사항</h4>
                    <ul className="ment">
                      {detailData?.Ment !== undefined &&
                        detailData?.Ment !== null &&
                        detailData.Ment?.map((el, i) => <li key={i}>{el}</li>)}
                    </ul>
                  </C.SideInfoWrapper>
                </C.StickyContents>
                {/* 웹 뷰*/}
                <FormProvider {...methods}>
                  <form
                    onSubmit={methods.handleSubmit((data) => submitCart(data))}
                    style={{ width: "100%" }}
                  >
                    <C.BodyWrapper>
                      <C.SideStickyWrapper>
                        <C.StickyContents className="pc_sticky">
                          <C.SideImageWrapper>
                            {/* 이미지 캐러셀 */}
                            {detailData.Images &&
                            detailData.Images.length > 0 ? (
                              detailData.Images.length > 1 ? (
                                <ImageSlider slides={detailData.Images} />
                              ) : (
                                <Image
                                  src={
                                    detailData.Images[0]?.url ||
                                    detailData.Image
                                  }
                                  alt="product-image"
                                  width={390}
                                  height={390}
                                  style={{
                                    width: "100%",
                                    maxWidth: "90%",
                                    height: "auto",
                                    objectFit: "contain",
                                    margin: "0 auto",
                                  }}
                                />
                              )
                            ) : (
                              // Images 배열이 비어있을 때 기본 이미지 표시
                              <Image
                                src={
                                  "https://file.caretbio.com/caretbio/0333577f5ebffe01e5fdb76d8479a7f1.jpeg"
                                }
                                alt="product-image"
                                width={390}
                                height={390}
                                style={{
                                  width: "100%",
                                  maxWidth: "90%",
                                  height: "auto",
                                  objectFit: "contain",
                                  margin: "0 auto",
                                }}
                              />
                            )}
                          </C.SideImageWrapper>

                          <C.SideInfoWrapper>
                            <div className="top">
                              <h4 className="title">상품 안내 사항</h4>
                              {category?.code === "M0039" && (
                                <a
                                  href={
                                    introductions.find(
                                      (el) => el.code === "F2313"
                                    )?.url || ""
                                  }
                                  target="_blank"
                                  download={`제품소개서_리펄프테이프.pdf`}
                                >
                                  자료 다운로드
                                </a>
                              )}
                            </div>
                            <ul className="ment">
                              {detailData?.Ment !== undefined &&
                                detailData?.Ment !== null &&
                                detailData.Ment?.map((el, i) => (
                                  <li key={i}>{el}</li>
                                ))}
                            </ul>
                          </C.SideInfoWrapper>
                        </C.StickyContents>
                      </C.SideStickyWrapper>
                      {/* 왼쪽 디테일 컴포넌트 */}
                      <ProductDetail
                        detailData={detailData}
                        category={category}
                        onChangeUserInputs={onChangeUserInputs}
                        directConfirm={directConfirm}
                        isUser={isUser}
                        cnt={cnt}
                        cntError={cntError}
                        setIntroductions={setIntroductions}
                        modalContents={modalContents}
                        setModalContents={setModalContents}
                      />
                    </C.BodyWrapper>
                    {/* 상세 가이드 모달 컴포넌트 */}
                    {modalContents.show && (
                      <CustomizingModal
                        modalContents={modalContents}
                        setModalContents={setModalContents}
                      />
                    )}
                  </form>
                </FormProvider>
              </C.StepSection>
            )}
          </div>
          {/* end: image carousel + input form */}
        </C.CustomNewSection>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomizingDetailPage);
